<template>
	<div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="searchblock">
					<search></search>
				</div>
				<!-- 列表 -->
				<div class="proList">
					<div class="catpop">
						<div class="in d-flex j-center a-center">
							<div class="box d-flex">
								<div class="ctree">
									<el-tree 
									:data="categoryTree" 
									show-checkbox 
									node-key="id" 
									:props="defaultProps"
									@check="handleNodeCheck"></el-tree>
								</div>
								<div class="cright d-flex">
									<div class="cbd">
										<el-table :data="proList" style="width: 100%">
											<el-table-column prop="name" class-name="pname" :label="$t('feedback.productName')">
												<template slot-scope="scope">
												<a href="javascript:;" v-if="scope.row.isIpProject" @click="goToPage('/ipProduct?id='+scope.row.id)">{{scope.row.name}}</a>
												<a href="javascript:;"  v-else @click="goToPage('/productDirectory?productId='+scope.row.id)">{{scope.row.name}}</a>
										</template>	
										</el-table-column>
											<el-table-column prop="publishTime" :label="$t('commom.date')" width="200"
												align="center"></el-table-column>
										</el-table>
									</div>
									<div class="cft">
										<div class="pgs">
											<el-pagination background :page-size="pageSize" :total="total" @current-change="searchPro"
												:current-page="pageCur" layout="prev, pager, next,jumper">
											</el-pagination>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>

export default {
	name: 'ProductList',
	components: {

	},
	data() {
		return {
			defaultProps:{
				label:"name",
				children:"children"
			},
			categoryTree: [],
			proList:[],
			ipproduct: [],
			pageCur: 1,
			pageSize: 10,
			total: 0,
			selectTemp: [],
			selectAllIds: [],
			selectPro: '',
		}
	},

	created() {
		// 获取产品目录
		this.getCategory();
	},

	methods: {
		getCategory() {//获取类别，初始产品列表
			this.$axios.get(`product/catalogue`)
				.then(res => {
					let data = res.data;
					this.categoryTree = data;
					this.selectAllIds = this.getChildIds({
						id: '',
						children: data
					}, []);
					this.selectTemp = this.selectAllIds;
					this.searchPro();
				})
				.catch(err => { })
		},
		handleNodeCheck(a, b) {//选中类别筛选
			var ids = [];
			b.checkedNodes.forEach(i => {
				if (i.children.length == 0) {
					ids.push(i.id)
				}
			})
			this.selectTemp = ids.length == 0 ? this.selectAllIds : ids;
			this.searchPro()
		},

		getChildIds(obj, result) {
			if (!obj.children || obj.children.length === 0) {
				result.push(obj.id);
			} else {
				obj.children.forEach(child => {
					this.getChildIds(child, result);
				});
			}
			return result;
		},
		searchPro() {//获取产品列表
			var that = this;
			this.$axios.get(`common/select/product?categoryId=${that.selectTemp.join(',')}&pageNo=${that.pageCur}`)
				.then(res => {
					that.proList = res.data.list;
					that.total = res.data.total
				})
				.catch(err => { })
		},
		// 页面跳转
		goToPage(path, query = {}) {
			this.$router.push({
				path,
				query
			})
		},
		// 获取产品目录
		getDirectoryContent() {
			this.$axios.get(`product/catalogue`)
				.then(res => {
					let data = res.data;
					this.directoryContent = data;
				})
				.catch(err => { })
		},
		getProductVoList() {
			this.$axios.post('member/ipProductPage')
				.then(res => {
					this.ipproduct = res.data.list;
				})
				.catch(err => { })
		}
	}
}
</script>
  
<style lang="less" scoped>
.searchblock {
	margin: 0.5rem 0;
}

/deep/.el-pager li {
	background: none;
	font-size: 16px;
	font-weight: normal;
}

.catpop .cright .sqr {
	display: inline-block;
	width: 16px;
	height: 16px;
	vertical-align: middle;
	border: 1px solid #ccc;
	cursor: pointer;
	color: transparent;
	transition: .3s;
	line-height: 12px;
	text-align: center;
}

.catpop .cright .sqr.cur {
	border-color: #409eff;
	background: #409eff;
	color: #fff;
}

.catpop .cright .sqr::before {
	font-size: 12px;
}

.catpop .in {
	width: 100%;
	height: 100%;
}

.catpop .box {
	width: 100%;
	background: #fcfcfc;
	align-items: stretch;
}
.proList{
	border: 1px solid #d9d9d9;
	border-radius: 10px;
	overflow: hidden;
}
.ctree {
	flex: 0 0 auto;
	width: 300px;
	padding: 30px;
	border-right: 1px solid #d9d9d9;
}

.el-tree {
	background: none;
}

.ctree /deep/ .el-tree-node__content {
	height: 40px;
}

.ctree /deep/ .el-tree-node__label {
	font-size: 16px;
}

.catpop .cright {
	flex: 1 1 auto;
	flex-direction: column;
	padding: 30px;
	padding-bottom: 50px;
	overflow: hidden;
}

.catpop .cright .ctp {
	width: 100%;
	flex: 0 0 auto;
}

.catpop .cright .btns {
	margin-left: 10px;
}

.catpop .cright .lb {
	padding-right: 10px;
}

.catpop .cright .ctp input {
	background: #eceff6;
	width: 300px;
}

.catpop .cright .cbd {
	margin: 20px 0;
	flex: 1 1 auto;
	width: 100%;
}
/deep/.el-table, /deep/.el-table__expanded-cell{
	background: none;
}
/deep/.pname .cell {
	padding-left: 40px;
	position: relative;
}

/deep/td.pname .cell:before {
	content: "";
	width: 6px;
	height: 6px;
	position: absolute;
	left: 15px;
	top: 50%;
	margin-top: -3px;
	background: #409eff;
}

/deep/.el-table .el-table__cell.pname {
	padding-top: 20px;
	padding-bottom: 20px;
}

.catpop .cright /deep/ .el-table th.el-table__cell {
	background: #e3e8ee;
	text-align: center;
	color: #002e8a;
	font-weight: normal;
}

.catpop .cright .el-table * {
	font-family: inherit;
	font-size: inherit;
	font-weight: normal;
}

.catpop /deep/ .el-tree-node__content {
	position: relative;
	background: none !important;
}

.catpop /deep/ .el-tree-node__expand-icon {
	position: absolute;
	right: 0;
}

.cright .el-table {
	font-size: inherit;
}

.catpop .cright .cft {
	align-items: center;
	justify-content: space-between;
	width: 100%;
	text-align: center;
	padding-top: 30px;
}
/deep/.el-table tr{
	background: none;
}
.ctree::-webkit-scrollbar,
.selects::-webkit-scrollbar {
	width: 4px;
	height: 1px;
}

.ctree::-webkit-scrollbar-thumb {
	border-radius: 4px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
	background: #264f8c;
}

.ctree::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background: #f2f2f2;
}

.input {
	line-height: 0.5rem;
}

@media(max-width:768px) {
	.catpop .box {
		display: block;
		overflow: auto;
		background: #fff;
		padding: 20px;
	}

	.ctree {
		width: auto;
		padding: 20px 0;
		border: none;
	}

	.catpop .cright {
		padding: 0;
	}

	/deep/.el-button {
		padding: 5px 10px;
		font-size: 12px;
	}

	.catpop .cright .ctp {
		display: block;
	}

	.catpop .cright .btns {
		text-align: right;
		margin-top: 10px;
		margin-left: 0;
	}

	.catpop .cright .ctp .inp {
		flex: 1;
	}

	.catpop .cright .ctp input {
		height: 30px;
	}

	/deep/.el-table .el-table__cell:nth-child(2),
	colgroup col:nth-child(2) {
		width: 40px !important;
	}

	/deep/.el-table .el-table__cell.pname {
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.catpop .cright .cft {
		display: block;
	}

	/deep/.el-dialog--center .el-dialog__body {
		padding: 0;
	}


	.ctree /deep/.el-tree-node__content {
		height: 30px;
	}

	.ctree /deep/.el-tree-node__label {
		font-size: 14px;
	}

	/deep/.el-pager li {
		font-size: 14px;
	}
}</style>
  